import { GraphQLClient } from 'graphql-request';
import * as HttpStatus from 'http-status-codes';
import i18next from 'i18next';
import { DEFAULT_API_URL } from './shared/utils/constants';
import { getToken, clearAuth } from './auth';
import { showNotificationAutoDestroy } from './shared/components/ShowNotification';

export default async function main(query, variables) {
  const graphQLClient = new GraphQLClient(`${DEFAULT_API_URL}/graphql/`, {
    headers: {
      Authorization: getToken(),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  try {
    const data = await graphQLClient.request(query, variables);
    return data;
  } catch (error) {
    if (error.response) {
      const { errors, status } = error.response;

      if (
        status === HttpStatus.FORBIDDEN ||
        status === HttpStatus.UNAUTHORIZED
      ) {
        clearAuth();
        window.location.href = '/minime';
      }
      if (status === HttpStatus.INTERNAL_SERVER_ERROR) {
        showNotificationAutoDestroy(
          'danger',
          i18next.t('errors.title'),
          error.response.message
        );
      }
      let message;
      errors.forEach((err) => {
        message += err.message;
      });
      if (message.indexOf('StatusCode: [422]') >= 0) {
        let messageTitle;
        let messageBody;
        const iuguMessage = JSON.parse(
          message.substring(message.indexOf('ResponseText: ') + 14)
        );
        iuguMessage.forEach((mes) => {
          Object.keys(mes.errors).forEach((k) => {
            messageTitle = k
              ? i18next.t(`iugu.errors.${k}`)
              : i18next.t('errors.title');
            // eslint-disable-next-line prefer-destructuring
            messageBody = mes.errors[k][0];
          });
        });
        showNotificationAutoDestroy('danger', messageTitle, messageBody);
      }
      if (message.indexOf(':') < 0) {
        showNotificationAutoDestroy(
          'danger',
          i18next.t('errors.title'),
          message
        );
      } else {
        showNotificationAutoDestroy(
          'danger',
          i18next.t('errors.title'),
          message.substring(message.indexOf(':') + 1)
        );
      }
    }
    throw error;
  }
}
